var styles = {"vjsNucleobase":"nv-video--vjs-nucleobase","hide-in-percy":"nv-video--hide-in-percy"};

export { styles as default };
//# sourceMappingURL=NvVideo.module.esm.js.map
